import $ from 'jquery';
require ('slick-carousel');
import {sanitize, getBreakpoint, toCssVar} from '../util';
$.fn.WebfactorySlick  = function(){
  const $wrapper = $(this);
  $wrapper.attr('class', ($wrapper.attr('class') || '').split(' ').filter(x=>!/^row/.test(x)).join(' '));
  let $block = $('<div role="wrapper"></div>');
  let $nav = $('<div role="nav"></div>')
  $wrapper.children().each(function(){
    $(this).appendTo($block);
  });
  $block.appendTo($wrapper);
  $nav.appendTo($wrapper);
  const options = $wrapper.data('carouselSlick');
  let settings = sanitize(options);
  let data = {...settings.md}
  data.responsive = ['sm', 'xs'].map(size=>{
    return {
      breakpoint: getBreakpoint(size),
      settings: settings[size]
    }
  })
  data.appendArrows = $nav;
  data.appendDots = $nav;
  $wrapper.parents('.wp-block-bootstrap-container').css('overflow','hidden');
  data.prevArrow = `<span class="slick-control slick-control-prev" >${wf_icon(options?.icons?.prev || 'svg-icon-arrow-left')}</span>`
  data.nextArrow = `<span class="slick-control slick-control-next" >${wf_icon(options?.icons?.next || 'svg-icon-arrow-right')}</span>`
  if (!$block.children().length){
    return;
  }
  data.layout = 'slick-carousel'
  let classes = ($(this).children().attr('class') || '').split(' ').filter(x=>!x.includes('col-md-')).join(' ');
  $block.children().attr('class', classes);
  let $ind = null;
  const updateIndicator = (i)=>{

    if (!$ind || !$ind.parent().children()[i] || !$ind.parent()[0]){
      return;
    }
    let rect2 = $ind.parent().children()[i].getBoundingClientRect();
    let rect1 = $ind.parent()[0].getBoundingClientRect();
    let [x, y] = [rect2.x - rect1.x, rect2.y - rect1.y]
    
    $ind.css({
      position: 'absolute',
      top: y,
      left: x,
      height: rect2.height,
      width: rect2.width,
    })
  }
  let slick = null;
  $block.on('init', function(e, s){
    slick = s;
    if (!s.$dots){
      return
    }
    if (s.$dots.css('position')!='absolute'){
      s.$dots.css('position', 'relative');
    }
    s.$dots.append('<span class="slick-indicator" ></span>')
    $ind = s.$dots.children('span.slick-indicator');
    updateIndicator(0);
  })
  $block.slick(data)
  const refresh = ()=>{
      if ($nav.find('.slick-control').length){
        $block.addClass('has-controls');
        $wrapper.addClass('has-controls');
      }
      else{
        $block.removeClass('has-controls');
        $wrapper.removeClass('has-controls')
      }
  }

  $(window).on('resize', refresh)
  $block.on('beforeChange', (e, slick , prev, next)=>{ 
    updateIndicator(next)
  });
  refresh();


}


let init = function($scope){

  if (!$scope){
    $scope = $('body');
  }
  $scope.find('[data-carousel-slick]:not(.slick-initialized)').each(function(){		
    $(this).WebfactorySlick();
  });
}

$(document).ready(()=>init())
